import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useAppSelector, useAppDispatch } from '../hooks';
import { Link } from 'react-router-dom';
import { transmitterKindLabel } from '../types/transmitter';
import { editTransmitter } from '../actions/EditTransmitter';
const rollershade_setup = (id) => {
    const link = `/config/transmitter/${id}/setup`;
    return (_jsx("div", { style: { 'float': 'right' }, children: _jsx(Link, { to: link, children: "Installation" }) }));
};
export const ConfigTransmitterRow = (props) => {
    const dispatch = useAppDispatch();
    const devicesMap = useAppSelector(state => state.definitions.devices);
    const transmitter = devicesMap[props.id];
    if (!transmitter) {
        return null;
    }
    if (transmitter.transmitter_kind === undefined) {
        return null;
    }
    const active = true;
    const has_setup = transmitter.transmitter_kind == 'rollershade';
    const label_classes = 'inactive label ' + (active ? ' hidden' : '');
    const setup = has_setup ? rollershade_setup(transmitter.id) : '';
    return (_jsxs("div", { className: "config-transmitter-row", children: [_jsxs("div", { children: [transmitter.title, _jsx("span", { className: label_classes, children: "Inaktiv" }), setup] }), _jsx("div", { children: transmitterKindLabel(transmitter.transmitter_kind) }), _jsx("div", { className: "pull-right", children: _jsx("button", { className: "edit lw small", onClick: () => dispatch(editTransmitter(transmitter.id)), children: "\u00A0Redigera\u00A0" }) })] }));
};
